<template>
    <vue-select
        v-bind="$attrs"
        v-on="$listeners"
        :options="options"
        ref="select"
    >
        <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
                Hittade inga resultat på <em>{{ search }}</em>.
            </template>
            <em style="opacity: 0.5;" v-else>Sök på säljare</em>
        </template>
    </vue-select>
</template>
<script>
import Repository from '@services/repositories/UserRepository';
import VueSelect from '@components/Wrappers/VueSelect';
import { sortLabelByAZ } from '@services/Helpers';

export default {
    name: 'SellerFilter',
    components: {
        VueSelect,
    },
    data() {
        return {
            allOptions: [],
        };
    },
    created() {
        const client = new Repository();
        client.getAll().then((res) => {
            this.allOptions = res.map((item) => ({
                label: item.first_name + ' ' + item.last_name,
                id: item.id,
                active: (!item.deleted_at),
                is_seller_sht: item.is_seller_sht,
            })).sort(sortLabelByAZ);
        });
    },
    computed: {
        options() {
            // console.log(this.$attrs.value);
            //  || vm.$refs.select.value === opt.id;
            const vm = this;
            return this.allOptions.filter((opt) => (opt.active && opt.is_seller_sht) || vm.$attrs.value === opt.id);
        },
    },
};
</script>
